(function () {
  function initPackSelectors() {
    document.querySelectorAll('.pack-selector').forEach(function (selector) {
      if (selector.dataset.packInit === 'true') return;
      selector.dataset.packInit = 'true';

      var qtyInput = document.getElementById(selector.dataset.quantityInputId);
      var options = selector.querySelectorAll('.pack-option');
      var radios = selector.querySelectorAll('.pack-option__radio');

      function setQuantity(qty) {
        if (!qtyInput) return;
        qtyInput.value = qty;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      }

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          options.forEach(function (opt) {
            opt.classList.remove('pack-option--selected');
          });
          var option = radio.closest('.pack-option');
          option.classList.add('pack-option--selected');
          setQuantity(option.dataset.packQty);
        });
      });

      var defaultOption = selector.querySelector('.pack-option--selected');
      if (defaultOption) {
        setQuantity(defaultOption.dataset.packQty);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPackSelectors);
  } else {
    initPackSelectors();
  }
})();
